import axiosInstance from "../../../../setup/axios/SetupAxios";

const API_URL = process.env.REACT_APP_BASE_URL;

export const FEEDBACK_URL = `${API_URL}/api/v1/parent/feedback`;
export const RATING_URL = `${API_URL}/api/v1/parent/rating`;

export function feedback(payload) {
    return axiosInstance({
        url: FEEDBACK_URL,
        method: "POST",
        data: payload
    })
}

export function rating() {
    return axiosInstance({
        url: RATING_URL,
        method: "GET"
    })
}